import { UploadFail } from './UploadFail';

export class FileWithoutHashFail extends UploadFail {
    radarName = 'fail_{SOURCE}_file-without-hash';
    message = 'Размер файла меньше 21 байт.';
}
